export const ACTION_TYPE = {
  NEXT: 'NEXT',
  PREV: 'PREV',
  GOTO: 'GOTO',
  DONE: 'DONE',
  RESET: 'RESET',
  VISIBILITY: 'VISIBILITY',
  DRAG: 'DRAG',
  LENGTH_UPDATED: 'LENGTH_UPDATED'
};
